module.exports = __webpack_public_path__ + "static/media/ball-eth.ad1a75ab.svg";